module.exports = __webpack_public_path__ + "static/media/greater-equal.21f3a4fd.svg";